import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Stack, styled } from '@mui/system';
import PlusIcon from '/src/assets/images/button/plus-dashboard.svg?url';
import FileUploadModal from './ModalPublish/FileUploadModal';
import { ACTION_BLUE } from '../../../theme/theme';

const StyledButton = styled(Button)(() => ({
  fontFamily: 'IRANYekanXFaNum',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  textTransform: 'none',
  width: '93px',
  height: '25px',
  borderRadius: '4px',
  padding: '2px 2px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'space-around',
  gap: '4px',
  color: '#FFFFFF',
  backgroundColor: ACTION_BLUE,
  transition: 'background-color 0.3s',
  '&:hover': {
    backgroundColor: '#2c47f7',
  },
  '@media (max-width: 768px)': {
    width: '100%',
    fontSize: '0.9rem',
    mt: '3px',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    gap: '8px',
  },
}));

interface AddNewVersionProps {
  publisherId: string | '';
  applicationId: string | '';
}

const AddNewVersion: React.FC<AddNewVersionProps> = ({
  publisherId,
  applicationId,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Stack
        direction="row"
        justifyContent={'space-between'}
        sx={{ width: '100%' }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 500,
            fontFamily: 'IRANYekanXFaNum',
            fontSize: 12,
            wordWrap: 'break-word',
            color: '#A6AAB5',
            paddingLeft: '20px',
          }}
        >
          تاریخچه نسخه‌ها
        </Typography>
        <Typography
          sx={{
            fontWeight: 500,
            fontFamily: 'IRANYekanXFaNum',
            fontSize: 14,
            wordWrap: 'break-word',
            paddingLeft: 'px',
            paddingRight: '50px',
            color: '#A6AAB5',
          }}
        >
          <StyledButton
            onClick={() => setModalOpen(true)}
            endIcon={
              <img
                src={PlusIcon}
                alt="icon"
                style={{ width: '20px', height: '20px' }}
              />
            }
          >
            نسخه جدید
          </StyledButton>
        </Typography>
      </Stack>
      <FileUploadModal
        publisherId={publisherId}
        applicationId={applicationId}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default AddNewVersion;
